export const siteSettings = {
  name: "Finex Edge",
  link: "https://finexedge.com",
  email: "support@finexedge.com",
  appLink: "https://app.finexedge.com",
};
